import * as React from 'react';
import { Switch, Redirect, useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useAppSelector, useCanAccess } from '@common/hooks';
import {
  networks as networksSelector,
  selected as selectedOrganisation,
} from '@modules/organisation/selectors/organisation';
import { EComponentTypes } from '@common/definitions';
import Route from '../../common/components/route';
import RouteNotFound from '../../common/components/route-not-found';
import { SubNavigationBar } from '../../common/components/navigation-bar';

import CyclesContainer from './containers/cycles';
import LibraryContainer from './containers/competency-library';

import EvaluationFormsList from './containers/evaluation-forms';
import EvaluationFormContainer from './containers/evaluation-form';
import EvaluationsContainer from './containers/evaluations';
import { PerformanceContainer } from './containers/performance';
import CompetancyForm from './containers/competency-library/compentancy-form';
import ManageRatings from './containers/competency-library/manage-ratings';
import EvaluationForm from './containers/evaluations/evalution';
import LandingPage from './containers/landing-page';
import BulkEvaluations from './containers/evaluations/bulk-evaluations';

const PerformanceTemplate = ({ match: { params } }) => {
  const basePath = params.networkId ? '/networks/:networkId' : '/admin';
  const canAccess = useCanAccess({
    components: EComponentTypes.PERFORMANCE_REVIEWS,
  });


  if (!canAccess) {
    return <LandingPage />;
  }
  return (
    <Switch>
      <Route
        exact
        path={[
          '/admin/performance',
          '/admin/performance/competency-library/all',
          '/admin/performance/competency-library/archived',
          `${basePath}/performance/evaluations`,
          `${basePath}/performance/my-evaluations`,
          '/admin/performance/forms',
          `${basePath}/performance/reports/performance-rating`,
          `${basePath}/performance/reports/employees`,
          `${basePath}/performance/reports/talent-reviews`,
        ]}
        component={PerformanceContainer}
      />

      <Route
        path={[
          `${basePath}/performance/competency-library/new-competency`,
          `${basePath}/performance/competency-library/:id/edit`,
        ]}
        component={CompetancyForm}
      />
      <Route
        path={`${basePath}/performance/competency-library/manage-rating-scale`}
        component={ManageRatings}
      />
      <Route
        path={[
          `${basePath}/performance/evaluations/:id`,
          `${basePath}/performance/my-evaluations/:id`,
        ]}
        component={EvaluationForm}
      />
      <Route
        path={[
          `${basePath}/performance/forms/:id/edit/components/:componentId`,
          `${basePath}/performance/forms/:id/edit`,
          `${basePath}/performance/forms/create`,
        ]}
        component={EvaluationFormContainer}
      />
      <Route
        path={`${basePath}/performance/bulk-evaluation`}
        component={BulkEvaluations}
      />
      <Route component={RouteNotFound} />
    </Switch>
  );

};

export default PerformanceTemplate;
